import OpTriggerSection from './OpTriggerSection/OpTriggerSection';

export default OpTriggerSection;
